$(document).ready(function () {



    /*
    * AURA
    * */
    let $auraView = $(".aura-item");
    let $colorBlock = $auraView.find(".colorBlock");
    function createColorPicker() {
        $("#colorPicker").farbtastic(changeColor);
        $.farbtastic("#colorPicker").setColor("#ff1b00");
    }
    function changeColor(color) {
        $colorBlock.css({
            "backgroundColor": color
        });
    }
    createColorPicker();


    /*
    * Parallax
    * */
    let isIE;
    let fixid = 0;
    let timer;
    function createParallax() {
        $('.jarallax').jarallax({
            speed: 0.2,
            automaticResize: true
        });
        createTimer();
    }
    function createTimer() {
        window.setInterval(function () {
            $('.jarallax').jarallax('onResize');
        }.bind(this), 300);
        /*if (timer) clearTimer();
        if (fixid < 10) {
            timer = window.setTimeout(function () {
                fixid++;
                clearTimer();
                $('.jarallax').jarallax('onResize');
                createTimer();
            }.bind(this), 300);
        }*/
    }

    function clearTimer() {
        window.clearTimeout(timer);
        timer = null;
    }

    function detectIE() {
        let ua = window.navigator.userAgent;
        let msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        let trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        let edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }
        // other browser
        return false;
    }

    isIE = detectIE();
    if (isIE === false) {
        createParallax();
        $(".parallaxCon.isie").removeClass("active");
        $(".parallaxCon.iswebkit").addClass("active");
    } else {
        $(".parallaxCon.isie").addClass("active");
        $(".parallaxCon.iswebkit").removeClass("active");
    }

});